export { default as CarouselInductees } from './CarouselInductees';